import { http } from '../lib/api/http';
import { mapApiUserToClient, defaultUserShape } from './userMapper';

const CURRENT_USER_ENDPOINT = '/users/me';

let cachedProfile = null;
let inflightRequest = null;
const listeners = new Set();

const notify = profile => {
  listeners.forEach(listener => {
    try {
      listener(profile);
    } catch (error) {
      console.warn('sessionUser listener failed', error);
    }
  });
};

export function setSessionUser(profile) {
  const normalized = profile ? { ...defaultUserShape, ...profile } : null;
  cachedProfile = normalized;
  notify(normalized);
}

export function clearSessionUser() {
  cachedProfile = null;
  notify(null);
}

export function subscribeSessionUser(callback) {
  if (typeof callback !== 'function') {
    return () => {};
  }
  listeners.add(callback);
  if (cachedProfile !== null) {
    callback(cachedProfile);
  }
  return () => {
    listeners.delete(callback);
  };
}

async function requestSessionUser() {
  const response = await http.get(CURRENT_USER_ENDPOINT);
  const mapped = mapApiUserToClient(response.data || {});
  setSessionUser(mapped);
  return mapped;
}

export async function fetchSessionUser({ forceRefresh = false } = {}) {
  if (!forceRefresh && cachedProfile) {
    return cachedProfile;
  }
  if (forceRefresh) {
    inflightRequest = null;
  }
  if (!inflightRequest) {
    inflightRequest = requestSessionUser().finally(() => {
      inflightRequest = null;
    });
  }
  return inflightRequest;
}

export async function refreshSessionUser() {
  return fetchSessionUser({ forceRefresh: true });
}

export async function getSessionUser(options = {}) {
  if (options.forceRefresh || !cachedProfile) {
    return fetchSessionUser({ forceRefresh: options.forceRefresh });
  }
  return cachedProfile;
}

export async function getSessionUserId(options = {}) {
  const profile = await getSessionUser(options);
  return profile?.id || '';
}
